import Head from 'next/head'
import { FC } from 'react';

export const GlobalMetas: FC = () => {
    return (
        <Head>
            {/* viewport */}
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5, viewport-fit=cover"/>
            {/* 禁止移动端号码邮箱的自动识别 */}
            {process.env.NEXT_PUBLIC_TERMINAL === 'm' && <meta name="format-detection" content="telephone=no,email=no"/>}
        </Head>
    )
};
